import useTypedPage from './useTypedPage';

type domain = 'app' | 'website';
export default function useForceUrlDomain(
  url: string,
  forceDomain: domain
): string {
  const pageProps = useTypedPage().props;
  let domain = pageProps.app_website_url;
  if (forceDomain === 'website') {
    domain = pageProps.wp_website_url;
  }
  const urlObj = new URL(url);
  const domainObj = new URL(domain);
  if (urlObj.hostname !== domainObj.hostname) {
    urlObj.hostname = domainObj.hostname;
  }

  return urlObj.toString();
}
